import styled, { css } from 'styled-components';
import { suppressProps } from '../../utils/index.js';
import { Flex } from '../flex/index.js';
export const StackElement = styled(Flex).withConfig(suppressProps('gapBetweenChildren'))(({ gapBetweenChildren = 'x2', direction, theme }) => {
    const gap = theme.space[gapBetweenChildren];
    return css `
    column-gap: ${direction.includes('row') && gap};
    row-gap: ${direction.includes('column') && gap};
  `;
});
//# sourceMappingURL=stack.styles.js.map